import { Maximize } from "@mui/icons-material";
import { t } from "i18next";
import Joi from "joi";
import {
  EMAIL_REGEX,
  LATITUDE_REGEX,
  LONGITUDE_REGEX,
  MAX_FILE_SIZE,
  MAX_TEXT_FIELD_SIZE,
  PHONE_REGEX,
} from "src/resources/constant";
import _ from "lodash";
import {
  calculateFileSizeFromBase64,
  isAllowedFileExtension,
} from "src/utils/helpers";

export const registrationSchema = (BMCEditData: any, isEditMode: any) => {
  const schema = Joi.object({
    id: Joi.string().optional().allow("").allow(null),
    name: Joi.string()
      .required()
      .max(MAX_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", { field: t("companyName") }),
        "string.empty": t("fieldISRequired", { field: t("companyName") }),
        "string.max": t("maxLengthValidation", {
          maxLength: MAX_TEXT_FIELD_SIZE,
        }),
      }),
    tradeLicenseNumber: Joi.string()
      .required()
      .max(MAX_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("tradeLicenseNumber"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("tradeLicenseNumber"),
        }),
        "string.max": t("maxLengthValidation", {
          maxLength: MAX_TEXT_FIELD_SIZE,
        }),
      }),
    tradeLicenseExpiry: Joi.date()
      .required()
      .messages({
        "any.required": t("fieldISRequired", {
          field: "TradeLicense expiry date",
        }),
        "string.empty": t("fieldISRequired", {
          field: t("tradeLicenseExpiryDate"),
        }),
        "date.base": t("fieldMustBeAValidDate", {
          field: t("tradeLicenseExpiryDate"),
        }),
      }),
    civilDefenseLicense: Joi.string()
      .required()
      .max(MAX_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("civilDefenseLicenseNumber"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("civilDefenseLicenseNumber"),
        }),
        "string.max": t("maxLengthValidation", {
          maxLength: MAX_TEXT_FIELD_SIZE,
        }),
      }),
    civilDefenseLicenseExpiry: Joi.date()
      .required()
      .messages({
        "any.required": t("fieldISRequired", {
          field: t("civilDefenseLicenseExpiryDate"),
        }),
        "string.empty": t("fieldISRequired", {
          field: t("civilDefenseLicenseExpiryDate"),
        }),
        "date.base": t("fieldMustBeAValidDate", {
          field: t("civilDefenseLicenseExpiryDate"),
        }),
      }),
    categoryOfLicense: Joi.any()
      .required()
      .messages({
        "any.required": t("fieldISRequired", { field: t("categoryOfLicense") }),
        "string.empty": t("fieldISRequired", { field: t("categoryOfLicense") }),
      }),
    emirate: Joi.string()
      .required()
      .messages({
        "any.required": t("fieldISRequired", { field: t("emirate") }),
        "string.empty": t("fieldISRequired", { field: t("emirate") }),
      }),
    officeAddress: Joi.string()
      .required()
      .max(MAX_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", { field: t("officeAddress") }),
        "string.empty": t("fieldISRequired", { field: t("officeAddress") }),
        "string.max": t("maxLengthValidation", {
          maxLength: MAX_TEXT_FIELD_SIZE,
        }),
      }),
    street: Joi.string()
      .required()
      .max(MAX_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", { field: t("street") }),
        "string.empty": t("fieldISRequired", { field: t("street") }),
        "string.max": t("maxLengthValidation", {
          maxLength: MAX_TEXT_FIELD_SIZE,
        }),
      }),
    city: Joi.string()
      .required()
      .messages({
        "any.required": t("fieldISRequired", { field: t("city") }),
        "string.empty": t("fieldISRequired", { field: t("city") }),
      }),
    lon: Joi.string()
      .optional()
      .allow("")
      .allow(null)
      .max(MAX_TEXT_FIELD_SIZE)
      .pattern(new RegExp(LONGITUDE_REGEX))
      .messages({
        "string.pattern.base": t("optionalLongitudePatternValidation"),
        "string.max": t("maxLengthValidation", {
          maxLength: MAX_TEXT_FIELD_SIZE,
        }),
      }),
    lat: Joi.string()
      .optional()
      .allow("")
      .allow(null)
      .max(MAX_TEXT_FIELD_SIZE)
      .pattern(new RegExp(LATITUDE_REGEX))
      .messages({
        "string.pattern.base": t("optionalLatitudePatternValidation"),
        "string.max": t("maxLengthValidation", {
          maxLength: MAX_TEXT_FIELD_SIZE,
        }),
      }),
    officePhoneNumber: Joi.string()
      .pattern(new RegExp(PHONE_REGEX))
      .optional()
      .allow("")
      .allow(null)
      .messages({
        "string.pattern.base": `${t("mobileNumberPatternValidation")}`,
      }),
    contactPersonName: Joi.string()
      .required()
      .max(MAX_TEXT_FIELD_SIZE)
      .messages({
        "any.required": t("fieldISRequired", { field: t("contactPersonName") }),
        "string.empty": t("fieldISRequired", { field: t("contactPersonName") }),
        "string.max": t("maxLengthValidation", {
          maxLength: MAX_TEXT_FIELD_SIZE,
        }),
      }),
    designation: Joi.string()
      .optional()
      .allow("")
      .allow(null)
      .max(MAX_TEXT_FIELD_SIZE)
      .messages({
        "string.max": t("maxLengthValidation", {
          maxLength: MAX_TEXT_FIELD_SIZE,
        }),
      }),
    territory: Joi.any().optional().allow("").allow(null),
    rating: Joi.any().optional().allow("").allow(null),
    phoneNumber: Joi.string()
      .pattern(new RegExp(PHONE_REGEX))
      .required()
      .messages({
        "any.required": t("fieldISRequired", { field: t("phoneNumber") }),
        "string.empty": t("fieldISRequired", { field: t("phoneNumber") }),
        "string.pattern.base": `${t("mobileNumberPatternValidation")}`,
      }),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .max(MAX_TEXT_FIELD_SIZE)
      .pattern(new RegExp(EMAIL_REGEX))
      .messages({
        "any.required": t("fieldISRequired", { field: t("email") }),
        "string.empty": t("fieldISRequired", { field: t("email") }),
        "string.email": t("emailPatternValidation"),
        "string.max": t("maxLengthValidation", {
          maxLength: MAX_TEXT_FIELD_SIZE,
        }),
        "string.pattern.base": t("emailPatternValidation"),
      }),

    numberOfTechnician: Joi.number()
      .min(0)
      .messages({
        "number.base": t("enterValidNumber"),
      }),
    numberofElectricalTechnician: Joi.number()
      .min(0)
      .messages({
        "number.base": t("enterValidNumber"),
      }),
    numberOfMechanicalTechnician: Joi.number()
      .min(0)
      .messages({
        "number.base": t("enterValidNumber"),
      }),
    numberOfCertifiedEngineers: Joi.number()
      .min(0)
      .messages({
        "number.base": t("enterValidNumber"),
      }),
    numberOfElectricalEngineer: Joi.number()
      .min(0)
      .messages({
        "number.base": t("enterValidNumber"),
      }),
    numberOfMechanicEngineer: Joi.number()
      .min(0)
      .messages({
        "number.base": t("enterValidNumber"),
      }),

    cDApprovedLicense: Joi.any()
      .custom((value, helpers) => {
        const fileSize = BMCEditData.cDApprovedLicense?.fileBase64
          ? calculateFileSizeFromBase64(
              BMCEditData.cDApprovedLicense.fileBase64
            )
          : 0;

        const fileExtension = BMCEditData.cDApprovedLicense?.fileName
          ?.split(".")
          .pop()
          .toLowerCase();

        if (!isEditMode && !BMCEditData.cDApprovedLicense?.fileName) {
          return helpers.error("cDApprovedLicense.required");
        } else if (
          fileSize > MAX_FILE_SIZE &&
          BMCEditData.cDApprovedLicense?.fileName
        ) {
          return helpers.error("cDApprovedLicense.maxSize");
        }
        if (fileExtension && !isAllowedFileExtension(fileExtension)) {
          return helpers.error("any.invalid");
        }
        return value;
      })
      .messages({
        "cDApprovedLicense.required": t("fieldISRequired", {
          field: t("attachedCDApprovedLicense"),
        }),
        "cDApprovedLicense.maxSize": t("fileSizeValidation", { size: "10MB" }),
        "any.invalid": `${t("fileTypeNote")}`,
      }),
  });
  _.forEach(BMCEditData, (value, key) => {
    if (!schema.$_terms.keys.some((item: any) => item.key === key)) {
      schema.$_terms.keys.push({
        key,
        schema: Joi.any().optional().allow("").allow(null),
      });
    }
  });
  return schema;
};
